import React, { Component } from 'react'

export default class SelectProvider extends Component {
  render() {
    const { children } = this.props

    return <>{children}</>
  }
}
